<template>
  <b-modal class="modal modal-confirm bg-body" id="ModalFormTindakan" size="xl">
    <template #modal-title>
      <h4 class="mb-0 text-left">Ubah Tagihan Tindakan Rawat Jalan</h4>
    </template>
    <div class="container-fluid">
      <Alert
        v-if="saveFailed"
        :alert="{
          type: 'danger',
          title: 'Gagal Menyimpan Data',
          content:
            'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
        }"
      />
      <Alert
        v-if="saveSuccess"
        :alert="{
          type: 'success',
          title: 'Berhasil Menyimpan Data',
          content: 'Penyimpanan data berhasil dilakukan',
        }"
      />
      <!-- <PageContentHeader
        :data="data"
        :fromUrl="fromUrl || ''"
        :fromTab="$route.query.fromTab || ''"
      />
      <DetailTop v-if="detailTop" :detailTop="detailTop" />
      <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
        <div class="col-md-7 pr-1" v-if="detailLeftTop">
          <DetailLeft :detailLeftTop="detailLeftTop" />
        </div>
        <div class="col-md-5 pl-1" v-if="detailRightTop">
          <DetailRight :detailRightTop="detailRightTop" />
        </div>
      </div> -->
      <!--form action="/ralan/save" method="POST" enctype="multipart/form-data"-->
      <div class="row">
        <div class="col-md-12" style="position: relative">
          <div class="mt-4">
            <FormRow
              v-for="row in tindakanForm"
              v-bind:key="row.colnum + String(Math.random(1023))"
              :row="row"
              @handleChange="(e) => handleChange(e)"
            />
          </div>
          <hr />

          <div class="d-flex flex-between mt-4 mb-3">
            <h5 class="mb-2">Penanganan oleh Dokter</h5>
          </div>
          <div class="form-group">
            <div class="input-group">
              <input
                type="text"
                :class="
                  'form-control form-control-lg pl-5 with-icon-left without-label ' +
                    (isError ? 'error' : '')
                "
                placeholder="Cari kode atau nama perawatan di sini"
                @input="
                  (e) => {
                    a_doc = false;
                    s_doc = e.target.value;
                    updateForm();
                  }
                "
                ref="s_doc"
                :value="s_doc"
                v-on:keyup.enter="() => search('doc')"
                @keyup.40="() => setFocus('doc')"
              />
              <i class="material-symbols-outlined" style="margin-top: -0.25rem"
                >search</i
              >
              <div class="input-group-append">
                <button
                  class="btn btn-secondary btn-with-icon-left"
                  @click="() => search('doc')"
                >
                  <i class="material-symbols-outlined">search</i>
                  CARI
                </button>
              </div>
            </div>
          </div>
          <SearchResult
            type="doc"
            ref="doc"
            @addItem="(item) => addItem(item, 'doc')"
            v-if="s_doc && a_doc"
            :loading="l_doc"
            :data="r_doc"
          />

          <table v-if="doc.length" class="responsive">
            <thead>
              <th>KODE</th>
              <th>NAMA PERAWATAN</th>
              <th>KATEGORI PERAWATAN</th>
              <th>TARIF/BIAYA</th>
              <th></th>
            </thead>
            <tbody>
              <tr
                v-for="item in doc.filter((item) => !item.deleted)"
                v-bind:key="item.id + Math.random(1024)"
              >
                <td>{{ item.kode }}</td>
                <td>{{ item.nama }}</td>
                <td>{{ item.kategori }}</td>
                <td>{{ item.formatted_biaya }}</td>
                <td>
                  <button
                    class="btn btn-icon btn-danger btn-sm"
                    @click="() => deleteItem('doc', item.id)"
                  >
                    <i class="material-symbols-outlined">delete</i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex flex-between mt-4 mb-3">
            <h5 class="mb-2">Penanganan oleh Petugas</h5>
          </div>
          <div class="form-group">
            <div class="input-group">
              <input
                type="text"
                :class="
                  'form-control form-control-lg pl-5 with-icon-left without-label ' +
                    (isError ? 'error' : '')
                "
                placeholder="Cari kode atau nama perawatan di sini"
                @input="
                  (e) => {
                    a_nrs = false;
                    s_nrs = e.target.value;
                    updateForm();
                  }
                "
                ref="s_nrs"
                :value="s_nrs"
                v-on:keyup.enter="() => search('nrs')"
                @keyup.40="() => setFocus('nrs')"
              />
              <i class="material-symbols-outlined" style="margin-top: -0.25rem"
                >search</i
              >
              <div class="input-group-append">
                <button
                  class="btn btn-secondary btn-with-icon-left"
                  @click="() => search('nrs')"
                >
                  <i class="material-symbols-outlined">search</i>
                  CARI
                </button>
              </div>
            </div>
          </div>
          <SearchResult
            type="nrs"
            ref="nrs"
            @addItem="(item) => addItem(item, 'nrs')"
            v-if="s_nrs && a_nrs"
            :loading="l_nrs"
            :data="r_nrs"
          />
          <table class="responsive" v-if="nrs.length">
            <thead>
              <th>KODE</th>
              <th>NAMA PERAWATAN</th>
              <th>KATEGORI PERAWATAN</th>
              <th>TARIF/BIAYA</th>
              <th></th>
            </thead>
            <tbody>
              <tr
                v-for="item in nrs.filter((item) => !item.deleted)"
                v-bind:key="item.id + Math.random(1024)"
              >
                <td>{{ item.kode }}</td>
                <td>{{ item.nama }}</td>
                <td>{{ item.kategori }}</td>
                <td>{{ item.formatted_biaya }}</td>
                <td>
                  <button
                    class="btn btn-icon btn-danger btn-sm"
                    @click="() => deleteItem('nrs', item.id)"
                  >
                    <i class="material-symbols-outlined">delete</i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex flex-between mt-4 mb-3">
            <h5 class="mb-2">Penanganan oleh Dokter dan Petugas</h5>
          </div>
          <div class="form-group">
            <div class="input-group">
              <input
                type="text"
                :class="
                  'form-control form-control-lg pl-5 with-icon-left without-label ' +
                    (isError ? 'error' : '')
                "
                placeholder="Cari kode atau nama perawatan di sini"
                @input="
                  (e) => {
                    a_both = false;
                    s_both = e.target.value;
                    updateForm();
                  }
                "
                ref="s_both"
                :value="s_both"
                v-on:keyup.enter="() => search('both')"
                @keyup.40="() => setFocus('both')"
              />
              <i class="material-symbols-outlined" style="margin-top: -0.25rem"
                >search</i
              >
              <div class="input-group-append">
                <button
                  class="btn btn-secondary btn-with-icon-left"
                  @click="() => search('both')"
                >
                  <i class="material-symbols-outlined">search</i>
                  CARI
                </button>
              </div>
            </div>
          </div>
          <SearchResult
            type="both"
            ref="both"
            @addItem="(item) => addItem(item, 'both')"
            v-if="s_both && a_both"
            :loading="l_both"
            :data="r_both"
          />
          <table class="responsive" v-if="both.length">
            <thead>
              <th>KODE</th>
              <th>NAMA PERAWATAN</th>
              <th>KATEGORI PERAWATAN</th>
              <th>TARIF/BIAYA</th>
              <th></th>
            </thead>
            <tbody>
              <tr
                v-for="item in both.filter((item) => !item.deleted)"
                v-bind:key="item.id + Math.random(1024)"
              >
                <td>{{ item.kode }}</td>
                <td>{{ item.nama }}</td>
                <td>{{ item.kategori }}</td>
                <td>{{ item.formatted_biaya }}</td>
                <td>
                  <button
                    class="btn btn-icon btn-danger btn-sm"
                    @click="() => deleteItem('both', item.id)"
                  >
                    <i class="material-symbols-outlined">delete</i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <div class="mt-4">
            <hr />

            <FormRow
              v-for="row in labForm"
              v-bind:key="row.colnum + String(Math.random(1023))"
              :row="row"
              @handleChange="(e) => handleChange(e)"
            />
            <hr />
          </div> -->
          <!-- <div class="d-flex flex-between mt-4 mb-3">
            <h5 class="mb-2">Pemeriksaan Lab</h5>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-md-12">
                <div class="input-group">
                  <input
                    type="text"
                    :class="
                      'form-control form-control-lg pl-5 with-icon-left without-label ' +
                      (isError ? 'error' : '')
                    "
                    placeholder="Cari kode atau nama pemeriksaan lab"
                    @input="
                      (e) => {
                        a_lab = false;
                        s_lab = e.target.value;
                        updateForm();
                      }
                    "
                    @keyup.40="() => setFocus('lab')"
                    ref="s_lab"
                    :value="s_lab"
                    v-on:keyup.enter="() => search('lab')"
                  />
                  <i class="material-symbols-outlined" style="margin-top: -0.25rem"
                    >search</i
                  >
                  <div class="input-group-append">
                    <button
                      class="btn btn-secondary btn-with-icon-left"
                      @click="() => search('lab')"
                    >
                      <i class="material-symbols-outlined">search</i>
                      CARI
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <SearchResult
            type="lab"
            ref="lab"
            @addItem="(item) => addItem(item, 'lab')"
            v-if="s_lab && a_lab"
            :loading="l_lab"
            :data="r_lab"
          />
          <table class="responsive" v-if="lab.length">
            <thead>
              <th>KODE</th>
              <th>NAMA PEMERIKSAAN LAB</th>
              <th>TARIF/BIAYA</th>
              <th>STATUS</th>
              <th></th>
            </thead>
            <tbody>
              <tr
                v-for="item in lab.filter((item) => !item.deleted)"
                v-bind:key="item.id + Math.random(1024)"
              >
                <td>{{ item.kode }}</td>
                <td>{{ item.nama }}</td>
                <td>{{ item.formatted_biaya }}</td>
                <td>{{ item.status }}</td>
                <td>
                  <button
                    class="btn btn-icon btn-danger btn-sm"
                    @click="() => deleteItem('lab', item.id)"
                    v-if="item.status != 'DIBATALKAN'"
                  >
                    <i class="material-symbols-outlined">delete</i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table> -->
        </div>
      </div>

      <!--/form-->
    </div>
    <template #modal-footer>
      <div class="w-100">
        <button
          class="btn btn-primary float-right"
          @click="
            () => {
              handleForm();
            }
          "
        >
          SIMPAN
        </button>
        <button
          type="button"
          class="btn btn-outline-primary mr-3 float-right"
          @click="$bvModal.hide('ModalFormTindakan')"
        >
          BATAL
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
// @ is an alias to /src
import Alert from "@/components/Alert.vue";
import SearchResult from "@/components/SearchResult.vue";
// import Navbar from "@/components/Navbar.vue";
// import Sidebar from "@/components/Sidebar.vue";
// import PageContentHeader from "@/components/PageContentHeader.vue";
// import DetailTop from "@/components/DetailTop.vue";
// import DetailLeft from "@/components/DetailLeft.vue";
// import DetailRight from "@/components/DetailRight.vue";
import FormRow from "@/components/FormRow.vue";
import {
  setPatientIntro,
  setRawatIntro,
  convertToRupiah,
  discounted,
  formatDiscount,
  getTimeWithSecond,
  getInputDate,
  resetForms,
} from "@/data/helper.js";
//console.log(discounted);
//console.log(formatDiscount);
// import { HTTP,HTTP_ENC } from "@/config.js";
import { data, tindakanForm, labForm } from "@/data/RalanFormTindakan.js";
export default {
  name: "ModalFormTindakan",
  components: {
    // Navbar,
    // Sidebar,
    // PageContentHeader,
    // DetailTop,
    // DetailLeft,
    // DetailRight,
    Alert,
    SearchResult,
    FormRow,
  },
  props: {
    no_rawat: String,
    id_ralan: Number,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      tindakanForm: tindakanForm,
      labForm: labForm,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      saveSuccess: false,
      saveFailed: false,
      formSet: {
        no_rawat: "",
        id_dokter: "",
        id_petugas: "",
        id_petugas_lab: "",
        lab_type: "Dewasa",
      },
      n: 0,
      s_lab: "",
      s_doc: "",
      s_nrs: "",
      s_both: "",
      r_lab: [],
      r_doc: [],
      r_nrs: [],
      r_both: [],
      lab: [],
      doc: [],
      nrs: [],
      both: [],
      a_lab: false,
      a_doc: false,
      a_nrs: false,
      a_both: false,
      l_lab: false,
      l_doc: false,
      l_nrs: false,
      l_both: false,
      isError: false,
    };
  },
  methods: {
    showModal() {
      this.$bvModal.show("ModalFormTindakan");
    },
    hideModal() {
      this.$bvModal.hide("ModalFormTindakan");
    },
    // handleForm() {
    //   this.$emit("onSave");
    //   this.hideModal();
    // },
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    handleFormOld: async function() {
      let self = this;
      self.errors = [];

      let valid = this.validateForm();
      if (valid) {
        // Object.keys(this.formSet).forEach(function(key) {
        //     formData.append(key, self.formSet[key]);
        // });
        //console.log({lab:this.lab,nrs:this.nrs,doc:this.doc,both:this.both});
        self.n =
          this.lab.filter((item) => !(item.deleted && !item.id_ralan_lab))
            .length +
          this.doc.filter((item) => !(item.deleted && !item.id_ralan_tindakan))
            .length +
          this.nrs.filter((item) => !(item.deleted && !item.id_ralan_tindakan))
            .length +
          this.both.filter((item) => !(item.deleted && !item.id_ralan_tindakan))
            .length;

        this.lab.forEach(async function(item) {
          if (!item.deleted) {
            let body = `no_rawat=${self["no_rawat"]}&id_petugas=${self.formSet["id_petugas_lab"]}&id_periksa_lab=${item.id}&kategori=${self.formSet.lab_type}&biaya=${item.biaya}`;
            if (!item.id_ralan_lab) {
              self.saveLab(body);
            } else {
              self.saveLab(body, item.id_ralan_lab);
            }
          } else {
            if (item.id_ralan_lab) {
              self.deleteLab(item.id_ralan_lab);
            }
          }
        });

        this.nrs.forEach(async function(item) {
          //n-=1;
          if (!item.deleted) {
            let body = `no_rawat=${self["no_rawat"]}&id_petugas=${self.formSet["id_petugas"]}&id_dokter=&id_tindakan=${item.id}&biaya=${item.biaya}`;
            if (!item.id_ralan_tindakan) {
              self.saveTindakan(body);
            } else {
              self.saveTindakan(body, item.id_ralan_tindakan);
            }
          } else {
            if (item.id_ralan_tindakan) {
              self.deleteTindakan(item.id_ralan_tindakan);
            }
          }
        });

        this.doc.forEach(async function(item) {
          //n-=1;
          if (!item.deleted) {
            let body = `no_rawat=${self["no_rawat"]}&id_dokter=${self.formSet["id_dokter"]}&id_petugas=&id_tindakan=${item.id}&biaya=${item.biaya}`;
            if (!item.id_ralan_tindakan) {
              self.saveTindakan(body);
            } else {
              self.saveTindakan(body, item.id_ralan_tindakan);
            }
          } else {
            if (item.id_ralan_tindakan) {
              self.deleteTindakan(item.id_ralan_tindakan);
            }
          }
        });

        this.both.forEach(async function(item) {
          //n-=1;
          if (!item.deleted) {
            let body = `no_rawat=${self["no_rawat"]}&id_dokter=${self.formSet["id_dokter"]}&id_petugas=${self.formSet["id_petugas"]}&id_tindakan=${item.id}&biaya=${item.biaya}`;
            if (!item.id_ralan_tindakan) {
              self.saveTindakan(body);
            } else {
              self.saveTindakan(body, item.id_ralan_tindakan);
            }
          } else {
            if (item.id_ralan_tindakan) {
              self.deleteTindakan(item.id_ralan_tindakan);
            }
          }
        });
      } else {
        //console.log(valid);
      }
    },
    handleForm: async function() {
      let self = this;
      self.errors = [];
      let valid = this.validateForm();
      if (valid) {
        let date = getInputDate();
        let today = new Date();
        let time = getTimeWithSecond(
          today.getHours(),
          today.getMinutes(),
          today.getSeconds()
        );

        let tindakans = [
          ...this.nrs.map((item) => {
            item.id_petugas = self.formSet["id_petugas"];
            return item;
          }),
          ...this.doc.map((item) => {
            item.id_dokter = self.formSet["id_dokter"];
            return item;
          }),
          ...this.both.map((item) => {
            item.id_petugas = self.formSet["id_petugas"];
            item.id_dokter = self.formSet["id_dokter"];
            return item;
          }),
        ]
          .filter((item) => !(item.deleted && !item.id_ralan_tindakan))
          .map((item) => {
            return {
              operation: item.deleted ? "delete" : null,
              no_rawat: self["no_rawat"],
              id_dokter: item.id_dokter ? Number(item.id_dokter) : null,
              id_petugas: item.id_petugas ? Number(item.id_petugas) : null,
              id_tindakan: Number(item.id),
              biaya: Number(item.biaya),
              tgl_tindakan: date,
              jam_tindakan: time,
            };
          });
        // let formDataTindakan = new FormData();
        // formDataTindakan.append('tindakans',tindakans);
        //console.log(tindakans);
        if (tindakans && tindakans.length) {
          try {
            let result = await this.$store.state.HTTP_JSON.post(
              `/ralan/tindakan/penanganan-bulk`,
              { tindakans }
            );
            //console.log(result);
            if (!result || result.status != 200) {
              this.saveFailed = true;
              this.saveSuccess = false;
              this.checkSuccess();
              return;
            }
          } catch (e) {
            //console.log(e);
            this.saveFailed = true;
            this.saveSuccess = false;
            this.checkSuccess();
            return;
          }
        }
        //console.log(this.lab);
        // let labs =
        //   this.lab && this.lab.length
        //     ? [...this.lab]
        //         .filter((item) => !(item.deleted && !item.id_ralan_lab))
        //         .map((item) => {
        //           return {
        //             operation: item.deleted ? "delete" : null,
        //             no_rawat: self["no_rawat"],
        //             id_petugas: self.formSet["id_petugas_lab"],
        //             id_periksa_lab: item.id,
        //             biaya: item.biaya,
        //             kategori: self.formSet["lab_type"],
        //           };
        //         })
        //     : [];
        //console.log(labs);

        // if (labs && labs.length) {
        //   try {
        //     let resultLab = await this.$store.state.HTTP_JSON.post(
        //       `/ralan/pemeriksaan/lab-bulk`,
        //       { labs: labs }
        //     );
        //     //console.log(resultLab);
        //     if (!resultLab || resultLab.status != 200) {
        //       this.saveFailed = true;
        //       this.saveSuccess = false;
        //       this.checkSuccess();
        //       return;
        //     }
        //   } catch (e) {
        //     //console.log(e);
        //     this.saveFailed = true;
        //     this.saveSuccess = false;
        //     this.checkSuccess();
        //     return;
        //   }
        // }
        this.checkSuccess();
      } else {
        //console.log(valid);
      }
    },
    async saveTindakan(body, id) {
      try {
        if (id) {
          let result = await this.$store.state.HTTP_ENC.put(
            `/ralan/tindakan/penanganan/${id}`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        } else {
          let result = await this.$store.state.HTTP_ENC.post(
            `/ralan/tindakan/penanganan`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        }
      } catch (e) {
        //console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    async deleteTindakan(id) {
      try {
        let result = await this.$store.state.HTTP_ENC.delete(
          `ralan/tindakan/penanganan/${id}`
        );
        //console.log(result);
        if (result.status == "200") {
          this.n = this.n - 1;
          if (this.n == 0) {
            this.checkSuccess();
          }
        }
      } catch (e) {
        //console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    async saveLab(body, id) {
      try {
        if (id) {
          //console.log(body);
          let result = await this.$store.state.HTTP_ENC.put(
            `ralan/pemeriksaan/lab/${id}`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        } else {
          let result = await this.$store.state.HTTP_ENC.post(
            `ralan/pemeriksaan/lab`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        }
      } catch (e) {
        //console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    async deleteLab(id) {
      try {
        let result = await this.$store.state.HTTP_ENC.delete(
          `ralan/pemeriksaan/lab/${id}`
        );
        //console.log(result);
        if (result.status == "200") {
          this.n = this.n - 1;
          if (this.n == 0) {
            this.checkSuccess();
          }
        }
      } catch (e) {
        //console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    checkSuccess() {
      if (!this.saveFailed) {
        this.saveSuccess = true;
        this.$emit("onSave");
        this.hideModal();
        var that = this;
        setTimeout(function() {
          that.saveSuccess = false;
        }, 1000);
      }
    },
    reset(url, stay) {
      // if (this.validated) {
      resetForms(
        this.formSet,
        [this.tindakanForm, this.labForm],
        true,
        this.handleChange
      );
      // }
      let fromTab = this.$route.query.fromTab;
      let backBtn = this.fromUrl.split("?")[0];
      if (!url) {
        if (this.fromUrl && fromTab) {
          let queryString = "?tab=" + fromTab;

          ////console.log(backBtn)
          this.$router.push({ path: backBtn + queryString });
        } else {
          ////console.log(window.history);
          if (backBtn) {
            this.$router.push({ path: backBtn });
          } else {
            this.$router.go(-1);
          }
        }
      } else {
        ////console.log(url);
        if (fromTab) {
          let queryString = "?tab=" + fromTab;
          let backBtn = url.split("?")[0];
          url = backBtn + queryString;
        }
        this.$router.push(url);
      }
    },
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
      }
      if (e.target.name == "lab_type") {
        let self = this;
        self.lab = self.lab.map(function(item) {
          //console.log(item);
          if (item.id_ralan_lab) {
            if (self.formSet["lab_type"] == "Dewasa") {
              item.biaya = item.periksalab.biaya_dewasa;
              item.formatted_biaya = item.periksalab.formatted_biaya_dewasa;
            } else {
              item.biaya = item.periksalab.biaya_anak;
              item.formatted_biaya = item.periksalab.formatted_biaya_anak;
            }
          } else {
            if (self.formSet["lab_type"] == "Dewasa") {
              item.biaya = item.biaya_dewasa;
            } else {
              item.biaya = item.biaya_anak;
            }
            item.formatted_biaya = convertToRupiah(item.biaya);
          }
          return item;
        });
      }
      this.updateForm();
      //console.log(this.formSet);
    },

    updateForm() {
      this.tindakanForm[0].columns[0].value = String(
        this.formSet["id_petugas"]
      );
      this.tindakanForm[0].columns[1].value = String(this.formSet["id_dokter"]);
      this.labForm[0].columns[0].value = String(this.formSet["id_petugas_lab"]);
      this.labForm[0].columns[1].value = this.formSet["lab_type"];
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      let forms = [this.tindakanForm, this.labForm].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name] &&
              (column.name == "id_petugas_lab"
                ? self.lab && self.lab.length
                : true)
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSet[column.name]) < 0
            ) {
              valid = false;
              column.error = "Nilai yang diisi tidak boleh negatif";
            } else {
              column.error = "";
            }
            if (self.formSet[column.name]) {
              column.value = self.formSet[column.name];
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.tindakanForm = forms[0];
      this.labForm = forms[1];
      //console.log(self.formSet);
      return valid;
    },
    fetchTindakan: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/tindakan/penanganan?no_rawat=${this.formSet["no_rawat"]}`
        );
        //console.log(result);
        let self = this;
        self.doc = [];
        self.both = [];
        self.nrs = [];
        if (result.status == "200") {
          let tindDoc = result.data.penanganan_dokter;
          tindDoc.forEach((item) => {
            item.nama = item.tindakan.nama;
            item.kategori = item.tindakan.kategori;
            item.kode = item.tindakan.kode;
            item.id_ralan_tindakan = item.id;
            item.id = item.tindakan.id;
            self.doc = self.doc.concat(item);
          });
          self.doc = self.doc.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
          let tindBoth = result.data.penanganan_dokter_petugas;
          tindBoth.forEach((item) => {
            item.nama = item.tindakan.nama;
            item.kategori = item.tindakan.kategori;
            item.kode = item.tindakan.kode;
            item.id_ralan_tindakan = item.id;
            item.id = item.tindakan.id;
            self.both = self.both.concat(item);
          });
          self.both = self.both.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
          let tindNrs = result.data.penanganan_petugas;
          tindNrs.forEach((item) => {
            item.nama = item.tindakan.nama;
            item.kategori = item.tindakan.kategori;
            item.kode = item.tindakan.kode;
            item.id_ralan_tindakan = item.id;
            item.id = item.tindakan.id;
            self.nrs = self.nrs.concat(item);
          });
          self.nrs = self.nrs.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
          if (tindBoth.length) {
            self.formSet.id_petugas = String(tindBoth[0].id_petugas);
            tindakanForm[0].columns[0].value = self.formSet.id_petugas;
            self.formSet.id_dokter = String(tindBoth[0].id_dokter);
            tindakanForm[0].columns[1].value = self.formSet.id_dokter;
          } else {
            if (tindNrs.length) {
              self.formSet.id_petugas = String(tindBoth[0].id_petugas);
              tindakanForm[0].columns[0].value = self.formSet.id_petugas;
            }
            if (tindDoc.length) {
              self.formSet.id_dokter = String(tindBoth[0].id_dokter);
              tindakanForm[0].columns[1].value = self.formSet.id_dokter;
            }
          }
          //console.log(self);
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchLab: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/pemeriksaan/lab?no_rawat=${this.formSet["no_rawat"]}`
        );
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          self.lab = [];
          result.data.data.forEach((item) => {
            item.nama = item.periksalab.nama;
            item.kode = item.periksalab.kode;
            item.id_ralan_lab = item.id;
            item.id = item.periksalab.id;
            self.lab = self.lab.concat(item);
          });
          self.lab = self.lab.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
          //console.log(self.lab);
          if (result.data.data.length) {
            self.formSet.id_petugas_lab = String(
              result.data.data[0].id_petugas
            );
            labForm[0].columns[0].value = self.formSet.id_petugas_lab;
            self.formSet.lab_type = result.data.data[0].kategori;
            labForm[0].columns[1].value = self.formSet.lab_type;
          }
          //console.log(self['formSet']);
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchNurses: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `petugas?per_page=9999999999`
        );
        //console.log(result);
        if (result.status == "200") {
          let nurses = result.data.data.map((item) => {
            return { value: item.id, label: item.nama };
          });
          this.tindakanForm[0].columns[0].options = nurses;
          if (!this.formSet.id_petugas) {
            this.formSet.id_petugas = this.$store.state.id_petugas || "";
            if (this.formSet.id_petugas) {
              this.tindakanForm[0].columns[0].value = this.formSet.id_petugas;
            }
          }
          this.labForm[0].columns[0].options = nurses;
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },

    fetchDoctors: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "dokter?per_page=9999999999"
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log(result.data);
          let doctors = result.data.data;
          //console.log(doctors);
          this.tindakanForm[0].columns[1].options = doctors.map(function(item) {
            item.label = `${item.kode} | ${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
          this.tindakanForm[0].columns[1].value = this.formSet.id_dokter;
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    search: async function(type) {
      //console.log(type);
      this["a_" + type] = true;
      this["l_" + type] = true;

      let url;
      if (type == "lab") {
        url = "periksalab";
      } else {
        url = "tindakan";
      }
      try {
        let result = await this.$store.state.HTTP.get(
          `${url}?q=${this["s_" + type]}`
        );
        //console.log(result);
        if (result.status == "200") {
          // this['r_'+type]=result.data;
          let self = this;
          this["r_" + type] = result.data.map(function(item) {
            if (type == "lab") {
              item.biaya =
                self.formSet.lab_type == "Dewasa"
                  ? item.biaya_dewasa
                  : item.biaya_anak;
            }
            item.formatted_diskon = formatDiscount(
              item.tipe_diskon,
              item.diskon
            );
            item.biaya_awal = item.biaya;
            item.biaya = discounted(
              parseInt(item.biaya),
              item.tipe_diskon,
              parseFloat(item.diskon)
            );
            item.formatted_biaya = convertToRupiah(item.biaya);
            //console.log(item);
            return item;
          });
          //console.log(this['r_'+type]);
          self["l_" + type] = false;
        } else {
          this["r_" + type] = [];
          self["l_" + type] = false;
        }
      } catch (e) {
        this["r_" + type] = [];
        this["l_" + type] = false;
      }
    },
    addItem: async function(item, type) {
      if (!this[type].find((el) => el.id == item.id)) {
        this[type].push(item);
      }
      this["r_" + type] = [];
      this["s_" + type] = "";
      this["a_" + type] = false;
      this.$nextTick(() => this.$refs[`s_${type}`].focus());
      //console.log(this[type]);
    },
    deleteItem: async function(type, id) {
      this[type] = this[type].map(function(item) {
        if (item.id == id) {
          item.deleted = true;
        }
        return item;
      });
      //console.log(this[type]);
    },
    setFocus: async function(type) {
      ////console.log(type);
      if (this[`r_${type}`] && this[`r_${type}`].length) {
        // ////console.log(this[`r_${type}`]);
        // ////console.log(global.vm);
        // this.$nextTick(()=>this.$refs.doc.$refs.doc0.focus());
        document.getElementById(type + "0").focus();
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.data.toReset = (url) => this.reset(url);
    try {
      let result = await this.$store.state.HTTP.get(
        `ralan/${this.id_ralan}?darurat=0`
      );
      //console.log(result);
      if (result.status == "200") {
        //console.log('ralan');
        //console.log(result.data);
        this.detailTop = setPatientIntro(result.data.pasien);
        let detailRawat = setRawatIntro(result.data);
        this.detailLeftTop = detailRawat.detailLeftTop;
        this.detailRightTop = detailRawat.detailRightTop;
        //console.log('ralan');
        this.formSet["no_rawat"] = result.data.no_rawat;
        this.formSet["id_dokter"] = String(result.data.dokter.id);
        //console.log(this.formSet['no_rawat']);
      } else {
        //   this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }
    this.fetchNurses();
    this.fetchDoctors();
    this.fetchTindakan();
    this.fetchLab();
  },
};
</script>
